import React from "react";
import phoneDemo from "../../../assets/images/phone-demo.png";
import appStore from "../../../assets/images/app-store.png";
import googlePlay from "../../../assets/images/google-play.png";

const DownloadAppSection = () => {
  return (
    <div className="download-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <img src={phoneDemo} alt="" width="100%" />
          </div>
          <div className="col-lg-6">
            <div className="">
              <h1 className="font-weight-bold text-primary">
                A fast and secure way to send money home.
              </h1>
              <p>
                Download our app for free to send money online in minutes. Track
                your payments and view your transfer history from anywhere.
              </p>
              <div className="store mt-3">
                <img
                  src={appStore}
                  alt=""
                  height="50"
                  className="mr-2 cursor-pointer"
                  onClick={() =>
                    window.open(
                      "https://apps.apple.com/ng/app/ileero-remit/id1566849731",
                      "_blank"
                    )
                  }
                />
                <img
                  src={googlePlay}
                  alt=""
                  height="50"
                  className="cursor-pointer"
                  onClick={() =>
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.ileero.remit",
                      "_blank"
                    )
                  }
                />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="item-cont">
        <div className="item-2">
            <div className="img-cont">
            
            </div>
          </div>
          

        </div> */}
      </div>
    </div>
  );
};

export default DownloadAppSection;
